import { IAppState } from '../../redux';
import { COMMERCIAL_OWNER_EXPERIMENT } from '../../constants/experiments';

export const selectCommercialOwnerWidgetTitle = (state: IAppState) => {
  const { abExperiments } = state;

  return abExperiments[COMMERCIAL_OWNER_EXPERIMENT];
};
